import { FormGroup, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable()
export class FormService {
  public markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }

  public validateForm(formToValidate: AbstractControl, formErrors: any, messages: any, checkDirty?: boolean) {
    const form = formToValidate;
    for (const field in formErrors) {
      var messagesT = messages[field];
      if (field) {
        const control = form.get(field);
        if (control.hasOwnProperty('controls')) {
          var formErrorsT = formErrors[field];
          control['controls'].forEach(item => {
            this.validateForm(item, formErrorsT, messagesT);
          });
        }
        else {
          if (control && !control.valid) {
            if (!checkDirty || (control.dirty || control.touched)) {
              for (const key in control.errors) {
                if (key && key !== 'invalid_characters') {
                  formErrors[field] = '';
                  formErrors[field] = formErrors[field] || messagesT[key];
                } else {
                  formErrors[field] = formErrors[field] || messagesT[key](control.errors[key]);
                }
              }
            }
          }
          else {
            formErrors[field] = '';
          }
        }
      }
    }
    return formErrors;
  }

  public noWhiteSpaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').toString().trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'required': true };
  }
}
